'use client';

import React, { useRef, useState } from 'react';
import { Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { pl } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker-custom.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faXmark } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';
import '../../lakeview/daterange/DateRange.css';
import './DatePicker.css';

const DatePickerField = ({
  field,
  formData,
  handleFieldChange,
  defineClass,
  calculateReadOnly,
}) => {
  const today = new Date();
  const [open, setOpen] = useState(false);

  const wrapperRef = useRef();

  field.minDateNow = field.minDateNow !== false;

  const minDate = field.minDateNow
    ? today
    : field.minDate
      ? new Date(field.minDate)
      : undefined;

  const maxDate = field.maxDate ? new Date(field.maxDate) : undefined;
  const selectedDate = formData[field.name]
    ? new Date(formData[field.name])
    : null;

  const handleOpen = () => {
    if (!calculateReadOnly(field)) {
      setOpen(true);
    }
  };

  return (
    <Form.Group
      className={`form-group custom-date-picker ${field.hideOnPrint ? 'print-hide' : ''}`}
    >
      <Row>
        {/* Label */}
        {field.label && (
          <Form.Label
            htmlFor={field.name}
            onClick={() => {
              if (wrapperRef.current) {
                wrapperRef.current.click();
              }
            }}
            className="mb-2"
            style={{ cursor: 'pointer' }}
          >
            <strong> {field.label}</strong>
          </Form.Label>
        )}
      </Row>
      <Row>
        {/* Input */}
        <div className="datepicker-wrapper">
          <div className="my-3 search-bar shadow-sm p-0 bg-white rounded-pill d-flex flex-wrap gap-3 align-items-center justify-content-between w-auto">
            <div className="d-flex flex-wrap flex-grow-1 align-items-center gap-3 search-fields w-100">
              <div
                id={field.name}
                ref={wrapperRef}
                className={`w-100 datepicker-input ${open ? 'datepicker-input-active' : ''}`}
                onClick={handleOpen}
              >
                <FontAwesomeIcon icon={faCalendarDays} className="icon" />
                {selectedDate ? (
                  <span>{selectedDate.toLocaleDateString('pl-PL')}</span>
                ) : (
                  <span className="text-muted">Wybierz datę</span>
                )}
                {selectedDate && !calculateReadOnly(field) && (
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="clear-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFieldChange(field.name, '');
                    }}
                  />
                )}
              </div>
            </div>
          </div>

          {open && (
            <div className="calendar-popup">
              <DatePicker
                selected={selectedDate}
                onChange={(date) => {
                  handleFieldChange(
                    field.name,
                    date ? format(date, 'yyyy-MM-dd') : '',
                  );
                  setOpen(false);
                }}
                onClickOutside={() => setOpen(false)}
                inline
                locale={pl}
                minDate={minDate}
                maxDate={maxDate}
                calendarClassName="custom-calendar"
              />
            </div>
          )}
        </div>
      </Row>
    </Form.Group>
  );
};

export default DatePickerField;
